
import ModalAddProjectPresenter from "./ModalAddProjectPresenter";

export const ModalAddProject = ModalAddProjectPresenter;

export default ModalAddProject;